import { render, staticRenderFns } from "./RentAddressProofSection.vue?vue&type=template&id=fe55f496&scoped=true"
import script from "./RentAddressProofSection.vue?vue&type=script&lang=js"
export * from "./RentAddressProofSection.vue?vue&type=script&lang=js"
import style0 from "./RentAddressProofSection.vue?vue&type=style&index=0&id=fe55f496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe55f496",
  null
  
)

export default component.exports